import { IGroup, IPlayerGroup } from "@grassrootly/api/entities";
import { ISearchQuery } from "@grassrootly/api/entities/ISearchQuery";
import { provider } from "@grassrootly/api/providers";

export type GetPlayerGroupsPayload = ISearchQuery & {
  playerId?: number;
};

export const GetPlayerGroups = async (params: GetPlayerGroupsPayload): Promise<IPlayerGroup[]> =>
  provider.Request("/players/{id}/groups", params);
